import moment from 'moment';

export const getShortDateStr = (
  date: number,
  noDateStr = 'No Due Date'
): string => {
  if (date === 0) {
    return noDateStr;
  }

  const newDate = new Date(date * 1000);

  const localeOptions = { year: 'numeric', month: 'short', day: 'numeric' };

  return newDate.toLocaleDateString(
    'en-US',
    localeOptions as Intl.DateTimeFormatOptions
  );
};

export const getDateWithTimeStr = (
  date: number,
  noDateStr = 'No Date'
): string => {
  if (date === 0) {
    return noDateStr;
  }

  const newDate = new Date(date * 1000);

  const localeOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  return newDate.toLocaleDateString(
    'en-US',
    localeOptions as Intl.DateTimeFormatOptions
  );
};

export const getDaysRemaining = (incomingDate: number): number => {
  const nextPayDate = moment(incomingDate * 1000);
  const currentDate = moment();
  const daysDiff = nextPayDate.diff(currentDate, 'days');

  return daysDiff;
};
